import { render, staticRenderFns } from "./RecentPatients.vue?vue&type=template&id=8558a9ea"
import script from "./RecentPatients.vue?vue&type=script&lang=js"
export * from "./RecentPatients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports